<div class="fc-common-panel-wrapper">
    <div class="fc-common-panel-header">
        <h2 class="template-icon">
            <span class="fc-common-panel-header-title">
                {{textHeaderTitleDialog}}
            </span>
        </h2>
        <span class="fc-common-panel-header-close-btn"
              (click)="closeDialog()"></span>
    </div>
    <div class="fc-common-panel-body">
        <div class="row">
            <div *ngIf="!isNoData" class="doc-banner">
                {{textInfoSelect}}
            </div>
            <div *ngIf="isNoData" class="doc-banner" [ngClass]="{'no-data': isNoData}">
                {{textInfoNoDocument}}
            </div>
            <div *ngIf="!isNoData" class="doc-case-table-wrapper">
                <fc-responsive-ag-grid
                        id="grid-doc-case"
                        *ngIf="isPegasus" 
                        class="doc-table-grid" 
                        [gridOptions]="gridOptionsCase">
                </fc-responsive-ag-grid>
            </div>
            <div *ngIf="!isNoData" class="doc-standard-table-wrapper">
                <fc-responsive-ag-grid
                        id="grid-doc-standard"
                        *ngIf="!isPegasus"
                        class="doc-table-grid"
                        [gridOptions]="gridOptions">
                </fc-responsive-ag-grid>
            </div>
        </div>
    </div>
    <div class="fc-common-panel-footer">
        <div class="fc-common-panel-footer-buttons">
            <button class="fc-common-button modal-button outline-btn float-left non-margin-left"
                    type="button"
                    (click)="closeDialog()">
                <span>Cancel</span>
            </button>
            <button class="fc-common-button modal-button dark-green primary-button"
            (click)="save()" [ngClass]="{'disabled-btn': isNoData}">
                <span>Save</span>
            </button>
        </div>
    </div>
</div>

<ng-template #rowDetailsTemplateRef let-row="row">
    <tr class="expand-row" *ngFor="let document of row.documents">
        <td class="expand-content" colspan="4">{{document.title}}</td>
    </tr>
</ng-template>
